import React from "react";
import { Paper, Typography, Grid, Link } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(4),
    width: "20vw",
    height: "8rem",
    color: "white",
    background: theme.palette.primary.main,
  },
}));

const AddProductCard = ({ title, link, icon }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.card}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <Grid>
          <Typography style={{ fontSize: 20 }}>
            <Link href={link} style={{ color: "white" }} variant="inherit">
              {title}
            </Link>
          </Typography>
        </Grid>
        <Grid>{icon}</Grid>
      </div>
    </Paper>
  );
};

export default AddProductCard;
